import * as React from "react";
import Component from "../../../../AbstractComponent";
import Formatter from "../../../../../Localization/Formatter";
import Time from "../../../../../Time/Time";

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "../../NewCoach/NewCoachContents/CoachSummaryTable";

export class NewChargeStep5 extends Component {
  public renderSummary = () => {
    const { state } = this.props;
    const { newCharge, coachType } = state;
    const typeObj = this.props.getChargeTypeBySelect(newCharge?.typeIdForCharge);
    let labelText = '';
    if (coachType === "Receivable") {
      labelText = this.trans('charge-class-receivable');
    }
    if (coachType === "Payable") {
      labelText = this.trans('charge-class-payable');
    }
    if (coachType === "registerIncomingInvoice") {
      labelText = this.trans('charge-class-invoice');
    }

    let summaryArr = [];

    if (newCharge.amountForCharge) {
      summaryArr.push({
        label: this.trans("payment-summary-details/amount"),
        value: `${newCharge?.amountForCharge} ${this.props.app?.settings?.user?.currency.iso}`
      })
    }
    if (newCharge.selectedEntityForCharge) {
      summaryArr.push({
        label: this.trans("coach/summary/object-label"),
        value: newCharge?.selectedEntityForCharge?.displayName
      })
    }
    if (state.selectedAgency) {
      summaryArr.push({
        label: this.trans("coach/summary/object-label"),
        value: state.selectedAgency?.displayName
      })
    }
    if (state.selectedOwner) {
      summaryArr.push({
        label: this.trans("label-landlord"),
        value: state.selectedOwner?.displayName
      })
    }
    if (newCharge.selectedCounterpartyForCharge) {
      summaryArr.push({
        label: labelText,
        value: newCharge?.selectedCounterpartyForCharge?.displayName || newCharge?.name
      })
    }
    if (!!typeObj) {
      summaryArr.push({
        label: this.trans("payment-summary-details/type"),
        value: Formatter.checkTranslationType(this.trans(typeObj?.label, {}, "", typeObj?.system), typeObj?.label, typeObj?.system)
      })
    }
    if (newCharge.descriptionForCharge) {
      summaryArr.push({
        label: this.trans("payment-summary-details/description"),
        value: newCharge?.descriptionForCharge
      })
    }
    if (newCharge.dateOfPeriodForCharge) {
      summaryArr.push({
        label: this.trans("label-period"),
        value: Time.formatTwoDatesPeriod(Time.firstDateSelectedMonth(newCharge?.dateOfPeriodForCharge), Time.lastDateSelectedMonth(newCharge?.dateOfPeriodForCharge))
      })
    }
    if (newCharge.firstDateForCharge) {
      summaryArr.push({
        label: this.trans("owner-statement"),
        value: this.formatter.monthYearFormatDate(newCharge?.firstDateForCharge)
      })
    }
    if (newCharge?.isInvoice) {
      if (newCharge.invoiceDateForCharge) {
        summaryArr.push({
          label: this.trans("section/charge-field/invoicedate-label"),
          value: this.formatter.formatDate(newCharge?.invoiceDateForCharge)
        })
      }
      if ((state.chargeType === "payment" || state.coachType === "Payable" || state.coachType === "registerIncomingInvoice") && Number(newCharge.invoiceNumberForCharge) > 0) {
        summaryArr.push({
          label: this.trans("charge-summary-details/invoicenumber"),
          value: newCharge?.invoiceNumberForCharge
        })
      }
      if (Number(newCharge.vatPercentageForCharge) > 0) {
        summaryArr.push({
          label: this.trans("dialog/agencyfee-field/vatpercentage-label"),
          value: `${newCharge?.vatPercentageForCharge}%`
        })
      }
      if (Number(newCharge.vatForCharge) > 0) {
        summaryArr.push({
          label: this.trans("dialog/agencyfee-field/vat-label"),
          value: this.formatter.formatNumber(newCharge?.vatForCharge, this.props.app?.settings?.user?.currency)
        })
      }
    }
    if (state.attachments.length > 0) {
      state.attachments.forEach((attachment, index) => {
        summaryArr.push({
          label: index === 0 ? this.trans("title-attachments") : "",
          value:attachment.filename
        })
      })
    }

    return summaryArr;
  }
  render() {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("summary")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-create-subtitle-dutch-de", {entity: this.trans("charge-to-be-created")})}
        />
        <CoachSummaryTable
          tableRows={this.renderSummary()}
        />
      </div>
    )
  }
}